import { createContext, ReactNode, useEffect } from 'react';
import { useTheme } from '../states/theme';
import { useUserInfo } from '../states/user-info';
import { LibraryThemeStyles } from '../themes/LibraryThemeStyles';

const ThemeContext = createContext({});

interface ThemeProviderProps {
    children?: ReactNode;
}

export const ThemeProvider = ({
    children,
}: ThemeProviderProps): JSX.Element => {
    const theme = useTheme();
    const userInfo = useUserInfo();

    useEffect(() => {
        if (userInfo.dyslexic) {
            document.body.classList.add('is-dyslexic');
            document.body.style.fontFamily = 'open-dyslexic !important;';
        } else {
            document.body.classList.remove('is-dyslexic');
            document.body.style.fontFamily = '';
        }
    }, [userInfo.dyslexic]);
    return (
        <ThemeContext.Provider value={{}}>
            <LibraryThemeStyles theme={theme} />
            {children}
        </ThemeContext.Provider>
    );
};
